import React, { useState, useEffect} from 'react';
import '../../css/pages.css';
import language from '../../utils/LanguageSettings';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { fetchContactInfo } from '../functions/fetchContactInfo';
import { SOURCE_URL } from '../../config';
import RenderSnA from '../functions/renderSnA';
import { useInView } from 'react-intersection-observer';
import 'animate.css';
import { animationClass, animationStyle } from '../../utils/FadeInEffect';

const AboutUs: React.FC = () => {
  const { ref, inView } = useInView({
      threshold: 0.1,
      triggerOnce: true,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [content, setContent] = useState<any>();
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
        let data = await fetchContactInfo(language);
        if(data){
          setContent(data.attributes);
          setSeo(data?.attributes?.AboutSEO || null);
          setGa(data?.attributes?.AboutGA || null);
        }
        setLoading(false);
    };
    fetchData();
  }, [language]);

  if (loading) {
    return (<>
        <div id="loader">
            <div className="spinner-border"></div>
        </div>
    </>
    );
  }
  
  const bannerImage = content?.AboutBanner?.BannerImage?.data?.attributes?.url;
  const bannerImageTab = content?.AboutBanner?.BannerImageTab?.data?.attributes?.url ?? bannerImage;
  const bannerImageMob = content?.AboutBanner?.BannerImageMob?.data?.attributes?.url ?? bannerImageTab;

  const bannerImagePosition = content?.AboutBanner?.BannerImagePosition?.toLowerCase();
  const bannerImagePositionTab = content?.AboutBanner?.BannerImagePositionTab?.toLowerCase() ?? bannerImagePosition;
  const bannerImagePositionMob = content?.AboutBanner?.BannerImagePositionMob?.toLowerCase() ?? bannerImagePositionTab;

  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <section id="inner-banner" className="object-item about" data-imgposition={bannerImagePosition} data-imgpositiontab={bannerImagePositionTab} data-imgpositionmob={bannerImagePositionMob}>
        <img style={{objectPosition: bannerImagePosition}} className="object-desktop-image w-100 img-fit d-xl-block d-none ls-is-cached lazyloaded" src={SOURCE_URL + bannerImage} />
        <img style={{objectPosition: bannerImagePositionTab}} className="object-tab-image w-100 img-fit d-xl-none d-lg-block d-none ls-is-cached lazyloaded" src={SOURCE_URL + bannerImageTab} />
        <img style={{objectPosition: bannerImagePositionMob}} className="object-mobile-image w-100 img-fit d-lg-none d-block ls-is-cached lazyloaded" src={SOURCE_URL + bannerImageMob} />  
        <div className={"pxc banner-text " + content?.AboutBanner?.BannerTextColor?.toLowerCase() + "-color animated"} style={language == "en" ? {fontFamily: "Barlow"} : {fontFamily: "Noto Sans TC"}}>
            <div ref={ref} className={animationClass(inView, 'up')} style={animationStyle(inView,'up')}>
              <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.AboutBanner?.BannerText}</ReactMarkdown>
            </div>
        </div>
    </section>
    <section id="main-content" className="pb-5 page-content text-justify">
        <div className="static-pages container-fluid container-md" style={language == "en" ? {fontFamily: 'Barlow', maxWidth:"1090px"} : {fontFamily: 'Noto Sans TC', maxWidth:"1090px"}}>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.AboutContent}</ReactMarkdown>
            <p className="text-center">
                <a href={content?.AboutButtonLink?.URL} target={content?.AboutButtonLink?.OpenLinkInANewTab ? '_blank' : '_self'} className="default-btn d-inline-block mx-auto" style={{textDecoration: "none"}}>{content?.AboutButtonLink?.LinkText}</a>
            </p>
        </div>
    </section>
    </>
  );
};

export default AboutUs;